import { Tooltip } from "#components/Tooltip";

import CloudCustodianLogo from "../../assets/cloudcustodian.svg?react";
import CloudFormationLogo from "../../assets/cloudformation.svg?react";
import CodeLogo from "../../assets/code_icon.svg?react";
import TerraformLogo from "../../assets/terraform.svg?react";

export interface ResourceManagerIconProps {
  manager: string;
  size?: number;
}

export function ResourceManagerIcon({ manager, size = 14 }: ResourceManagerIconProps) {
  let Logo;

  if (manager.toLocaleLowerCase().includes("cloudcustodian")) {
    Logo = CloudCustodianLogo;
  } else if (manager.toLocaleLowerCase().includes("cloudformation")) {
    Logo = CloudFormationLogo;
  } else if (manager.toLocaleLowerCase().includes("terraform")) {
    Logo = TerraformLogo;
  } else {
    Logo = CodeLogo;
  }

  return (
    <div className="flex" style={{ height: size, width: size }}>
      <Tooltip
        buttonProps={{
          "aria-label": manager,
        }}
        title={manager}
      >
        <Logo height={size} width={size} />
      </Tooltip>
    </div>
  );
}
